import { FormHelperText, FormLabel, Group, Input, Typography } from '@screentone/core';

import { TreatmentTypeSetting } from 'data/generated/graphql';

interface ItemCountOverrideFieldsProps {
  treatmentTypeSetting: TreatmentTypeSetting;
  minItemsOverride: string;
  maxItemsOverride: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  validationError?: string;
  showMinOverride: boolean;
  showMaxOverride: boolean;
  disabled?: boolean;
}

export const ItemCountOverrideFields = ({
  treatmentTypeSetting,
  minItemsOverride,
  maxItemsOverride,
  onMinChange,
  onMaxChange,
  validationError,
  showMinOverride,
  showMaxOverride,
  disabled = false
}: ItemCountOverrideFieldsProps) => (
  <>
    {treatmentTypeSetting.optional && (
      <Typography variant="note" color="asphalt" margin={{ top: 'md' }} data-testid="optional-module-note">
        <strong>This is an Optional module</strong> — it can be published empty by default. Setting a min override
        removes that exemption and enforces the minimum on publish.
      </Typography>
    )}
    <Group gap="sm" align="stretch" fullWidth margin={{ top: 'md' }}>
      {showMinOverride ? (
        <Group.Item flex>
          <FormLabel label="Min Items Override" labelPosition="top">
            <Input
              type="number"
              min={0}
              max={99}
              value={minItemsOverride}
              placeholder={(treatmentTypeSetting.minRequiredContentItems as number | undefined)?.toString()}
              onChange={(e) => onMinChange(e.target.value)}
              disabled={disabled}
            />
            <FormHelperText>
              Default: {(treatmentTypeSetting.minRequiredContentItems as number | undefined) ?? '—'}
            </FormHelperText>
          </FormLabel>
        </Group.Item>
      ) : (
        <Group.Item flex>
          <Typography variant="note" color="asphalt">
            Min override is not available — the min validation is disabled for this page.
          </Typography>
        </Group.Item>
      )}
      {showMaxOverride ? (
        <Group.Item flex>
          <FormLabel label="Max Items Override" labelPosition="top">
            <Input
              type="number"
              min={0}
              max={99}
              value={maxItemsOverride}
              placeholder={(treatmentTypeSetting.maxRequiredContentItems as number | undefined)?.toString()}
              onChange={(e) => onMaxChange(e.target.value)}
              disabled={disabled}
            />
            <FormHelperText>
              Default: {(treatmentTypeSetting.maxRequiredContentItems as number | undefined) ?? '—'}
            </FormHelperText>
          </FormLabel>
        </Group.Item>
      ) : (
        <Group.Item flex>
          <Typography variant="note" color="asphalt">
            Max override is not available — the max validation is disabled for this page.
          </Typography>
        </Group.Item>
      )}
    </Group>
    {validationError && (
      <Typography variant="note" color="lava">
        {validationError}
      </Typography>
    )}
  </>
);
